module.exports = __webpack_public_path__ + "img/home_3.80c2cb22.jpg";